/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BountyLocationFromJSON, BountyLocationToJSON, } from './BountyLocation';
import { MapMarkerPropertiesDtoFromJSON, MapMarkerPropertiesDtoToJSON, } from './MapMarkerPropertiesDto';
/**
 * Check if a given object implements the GeoJsonFeatureDto interface.
 */
export function instanceOfGeoJsonFeatureDto(value) {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "geometry" in value;
    isInstance = isInstance && "properties" in value;
    return isInstance;
}
export function GeoJsonFeatureDtoFromJSON(json) {
    return GeoJsonFeatureDtoFromJSONTyped(json, false);
}
export function GeoJsonFeatureDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': json['type'],
        'geometry': BountyLocationFromJSON(json['geometry']),
        'properties': MapMarkerPropertiesDtoFromJSON(json['properties']),
    };
}
export function GeoJsonFeatureDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'geometry': BountyLocationToJSON(value.geometry),
        'properties': MapMarkerPropertiesDtoToJSON(value.properties),
    };
}
